
import { BehaviorSubject } from 'rxjs';

export const behaviorInstallment$ = new BehaviorSubject({});

export const behaviorInstallment = behaviorInstallment$.asObservable();